import {createAction, props} from '@ngrx/store';

export const setAllOperations = createAction('Set all operations', props<{ operations: any[] }>());
export const updateOneOperation = createAction('Update one operation', props<{ id: string, payload: any }>());
export const clearAll = createAction('[Navigation Bar] Clear Context');
export const setActive = createAction('Set Active Scheduled Operation', props<{ id: any }>());
